import QuestionButton from './QuestionButton';

export default QuestionButton;
